import React, { useState, useEffect } from "react"

const STORAGE_KEY = "happi:customer:jwt"

export interface CustomerContextData {
  customerToken: string | null
  setCustomer: (jwt: string | null) => void
}

export const context = React.createContext<CustomerContextData>(
  {} as CustomerContextData
)

export const CustomerProvider: React.FC<{}> = ({ children }) => {
  const [jwt, setJwt] = useState<string | null>(null)
  useEffect(() => {
    if (jwt) return

    const lookup = localStorage.getItem(STORAGE_KEY)

    if (lookup && lookup.length) {
      setJwt(lookup)
    }
  }, [])

  return (
    <context.Provider value={{
      customerToken: jwt,
      setCustomer: (jwt) => {
        setJwt(jwt)
        if (jwt) {
          localStorage.setItem(STORAGE_KEY, jwt)
        } else {
          localStorage.removeItem(STORAGE_KEY)
        }
      }
    }}>
      {children}
    </context.Provider>
  )
}
export const CustomerConsumer = context.Consumer

export default context
